import template from './mapFilterList.html';
import controller from './mapFilterList.controller';
import './mapFilterList.scss';

let mapFilterListComponent = {
  restrict: 'E',
  bindings: {
    filters: '<',
    orderChanged: '&'
  },
  template,
  controller
};

export default mapFilterListComponent;
